'use client';

import React, { ReactNode, Suspense } from 'react';
import { CSPostHogProvider } from './lib/posthog/provider';
import WithSession from './sessionProvider';
import ScormProvider from './lib/scorm/provider';
import { DatadogProvider } from './lib/datadog/provider';
import ServerActionSkewDialog from './ui/ServerActionSkewDialog';

export function Providers({ children }: { children: ReactNode }) {
	return (
		<CSPostHogProvider>
			<ScormProvider>
				<Suspense>
					<WithSession>
						<DatadogProvider>
							{children}
							<ServerActionSkewDialog />
						</DatadogProvider>
					</WithSession>
				</Suspense>
			</ScormProvider>
		</CSPostHogProvider>
	);
}
